export default {
  isochronesDetails: {
    polygons: 'Polygony',
    center: 'Střed',
    reachCenters: 'Centra dosahu',
    toggleVisibility: 'Přepnout viditelnost',
    opacity: 'Průhlednost'
  }
}
